import { FC } from "preact/compat";
import { useEffect } from "preact/hooks";
import { useSignal } from "@preact/signals";

const LoadingProgress: FC = () => {
    const progress = useSignal(0);

    useEffect(() => {
        const interval = window.setInterval(() => {
            progress.value +=
                progress.peek() < 80 ? 8 : progress.peek() < 95 ? 1 : 0;
        }, 100);

        return () => {
            window.clearInterval(interval);
        };
    }, [progress]);

    return (
        <div className="fixed z-40 top-[calc(var(--top-header))] h-1 w-full bg-gray-100">
            <div
                className="h-1 bg-sky-500 w-full transition-all duration-300 ease-out"
                style={{ width: `${progress.value}%` }}
            />
        </div>
    );
};

export default LoadingProgress;
